const ucb = require('./ucb');
const portal = window.portal || {};
const P = portal;

portal.Statis = portal.Statis || {};
const statis = portal.Statis;

// 如果在节点上找不到统计参数，则往上再查几级
const _getStatis = function($target, bubble) {
  if (bubble <= 0) {
    return undefined;
  }
  if (undefined === $target || $target.length === 0) {
    return undefined;
  }
  const statis = $target.attr('data-statis');
  if (statis !== null && undefined !== statis && statis.length >= 1) {
    return statis;
  }
  return _getStatis($target.parent(), --bubble);
};

statis.handler = function(event) {
  // 在需要统计的节点上，添加data-statis属性
  const $target = $(event.target);
  // 设置统计信息到cookie
  const statis = _getStatis($target, 5);
  if (statis != null && undefined != statis && statis.length >= 1) {
    ucb.Cookie.set('statis', statis, {
      path: '/',
      domain: '.9game.cn' // 揪心
    });
  } else {
    ucb.Cookie.remove('statis');
  }
};

statis.documentListener = function() {
  let event = 'click';
  if (ucb.Supports.Touch) {
    event = 'touchstart';
  } else if ('onmousedown' in window) {
    event = 'mousedown';
  }
  // 每个页面初始化的时候，清除已有的值，确保页面点击的统计数据是干净的
  ucb.Cookie.remove('statis');
  $(document).on(event, statis.handler);
};

// dom ready之后，开始监听事件

P.Statis.documentListener();




// WEBPACK FOOTER //
// ./lib/js/public/portal.js